export const messages = {
    loading: "Obteniendo datos del proveedor...",
    error: `Se produjo un error al consultar los datos del proveedor`,
};
